module.exports = __webpack_public_path__ + "img/Total.fc24dfec.png";